import { useTranslations } from '~/src/hooks/useTranslations'
import { Button } from '@mui/material'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

const CheckActivationRegisterWithOtherButton = () => {
  const { restart } = useAuthenticationFlowDialogs()
  const { t } = useTranslations()

  return (
    <Button
      variant='outlined'
      onClick={restart}>
      {t('auth.checkActivation.actions.registerWithAnOtherEmail')}
    </Button>
  )
}

export default CheckActivationRegisterWithOtherButton
